import './style.css'

export default class NoResults {
    static selector = '.no-results';

    constructor(block) {
        this.block = block;
    }
}
